import "./Anomalies.css";
import React from "react";
import moment from "moment";
import "../../css/table.css";
import "moment/locale/pt-br";
import { toArray } from "lodash";
import ReactTable from "react-table";
import { connect } from "react-redux";
import Card from "../../components/Card/Card.jsx";
import { db } from "../../services/firebase";
import Modal from "../../components/Modal/Modal.jsx";
import AnomalyForm from "../../forms/AnomalyForm.jsx";
import SweetAlert from "react-bootstrap-sweetalert";
import NotificationSystem from "react-notification-system";
import Button from "../../elements/CustomButton/CustomButton.jsx";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import SweetSpinner from "../../components/SweetSpinner/SweetSpinner.jsx";
import { style as NotifyStyle } from "../../variables/Variables.jsx";
import { Grid, Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import { faPencilAlt, faClipboard } from "@fortawesome/fontawesome-free-solid";

class Anomalies extends React.Component {
  state = {
    anomalies: [],
    fetching: true,
    targetAnomaly: null,
    anomalyModal: false,
    justificationModal: false,
    alert: null,
    _notificationSystem: null,
  };

  componentDidMount() {
    this._fetchAnomalies();
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  render() {
    const { anomalies, fetching } = this.state;

    console.log(anomalies);
    return (
      <div className="main-content">
        {this.state.alert}
        {this.anomalyModal()}
        {this.justificationModal()}
        <NotificationSystem ref="notificationSystem" style={NotifyStyle} />
        <Grid fluid>
          {/* <Button onClick={this.solvingShift}>Salve</Button> */}
          <Card
            content={
              <Row>
                <Col md={12}>
                  <ReactTable
                    columns={[
                      {
                        Header: "Data/Hora",
                        accessor: "registeredAt",
                        Cell: ({ value }) => {
                          return moment(value).format("DD/MM/YYYY - HH:mm");
                        },
                      },
                      { Header: "Produto", accessor: "product" },
                      { Header: "Indicador", accessor: "indicator" },
                      { Header: "Meta (gramas)", accessor: "goal" },
                      { Header: "Registrado (gramas)", accessor: "registered" },
                      {
                        Header: "Ações",
                        accessor: "",
                        Cell: ({ value }) => (
                          <div style={{ textAlign: "center" }}>
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id={`edit_${value.id}`}>
                                  Detalhes
                                </Tooltip>
                              }
                            >
                              <a
                                className="btn btn-simple btn-default btn-icon"
                                onClick={() =>
                                  this.setState({
                                    targetAnomaly: value,
                                    justificationModal: true,
                                  })
                                }
                              >
                                <FontAwesomeIcon
                                  className="text-dark"
                                  icon={faClipboard}
                                />
                              </a>
                            </OverlayTrigger>
                            {!value.cause &&
                              !value.solution &&
                              this.props.user.roleName === "Encarregado" && (
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip id={`edit_${value.id}`}>
                                      Justificar Anomalia
                                    </Tooltip>
                                  }
                                >
                                  <a
                                    className="btn btn-simple btn-default btn-icon"
                                    onClick={() =>
                                      this.setState({
                                        targetAnomaly: value,
                                        anomalyModal: true,
                                      })
                                    }
                                  >
                                    <FontAwesomeIcon
                                      className="text-dark"
                                      icon={faPencilAlt}
                                    />
                                  </a>
                                </OverlayTrigger>
                              )}
                          </div>
                        ),
                      },
                    ]}
                    data={anomalies}
                    loading={fetching}
                    defaultPageSize={10}
                    className="-striped -highlight"
                    previousText="Anterior"
                    nextText="Próximo"
                    loadingText="Carregando"
                    noDataText="Nenhuma anomalia encontrada"
                    pageText="Página"
                    ofText="de"
                    rowsText="Registros"
                  />
                </Col>
              </Row>
            }
          />
        </Grid>
      </div>
    );
  }

  anomalyModal = () => {
    const { targetAnomaly, anomalyModal } = this.state;
    return (
      <Modal
        title="Justificar Anomalia"
        isOpen={anomalyModal}
        content={
          <AnomalyForm
            onSubmit={(values) => this._updateAnomaly(targetAnomaly.id)(values)}
            handleCancel={() =>
              this.setState({ anomalyModal: false, targetAnomaly: null })
            }
          />
        }
      />
    );
  };

  justificationModal = () => {
    const { targetAnomaly, justificationModal } = this.state;

    if (targetAnomaly) {
      const {
        product,
        indicator,
        shift,
        place,
        line,
        table,
        user,
        goal,
        registered,
        registeredAt,
        cause,
        solution,
        justifiedBy,
      } = targetAnomaly;

      return (
        <Modal
          title="Anomalia"
          isOpen={justificationModal}
          content={
            <div>
              <Row>
                <Col md={12}>
                  <h3>
                    {product || "Nenhum produto"} -{" "}
                    {indicator || "Nenhum indicador"}
                    <br />
                    <small>
                      Coleta realizada em{" "}
                      {moment(registeredAt._d).format("DD/MM/YYYY - HH:mm")}
                    </small>
                    <br />
                    <small>
                      {shift || "Turno indefinido"} |{" "}
                      {place || "Local indefinido"} |{" "}
                      {line || "Linha indefinida"} |{" "}
                      {table || "Mesa indefinida"}
                    </small>
                    <br />
                    <small>
                      {user
                        ? `Coletor responsável: ${user}`
                        : "Coletor indefinido"}
                    </small>
                  </h3>
                  <br />
                </Col>
                <Col md={12} style={{ position: "relative" }}>
                  <div
                    className="anomaly__goal-box"
                    style={{ flexDirection: "column" }}
                  >
                    <h6>META</h6>
                    <h1 className="anomaly__goal">{goal || "-"}</h1>
                    <h6 className="anomaly__goal-footer">GRAMAS</h6>
                  </div>

                  <div
                    className="anomaly__registered-box"
                    style={{ flexDirection: "column" }}
                  >
                    <h6>REGISTRADO</h6>
                    <h1 className="anomaly__registered text-danger">
                      {registered || "-"}
                    </h1>
                    <h6 className="anomaly__registered-footer">GRAMAS</h6>
                  </div>
                  <h3>
                    &nbsp; <br />
                    <small>&nbsp;</small>
                    <br />
                    <small>&nbsp;</small>
                    <br />
                    <small>&nbsp;</small>
                  </h3>
                  <br />
                </Col>
              </Row>
              <Row>
                {cause && solution && (
                  <Col md={12}>
                    <blockquote>
                      <p>Causa: {cause}</p>
                      <p>Solução: {solution}</p>
                      <small>Justificativa registrada por {justifiedBy}</small>
                    </blockquote>
                  </Col>
                )}
              </Row>

              <Row>
                <Button
                  style={{ width: "50%", marginLeft: "25%", marginTop: 10 }}
                  bsStyle="default"
                  fill
                  onClick={() =>
                    this.setState({
                      justificationModal: false,
                      targetAnomaly: null,
                    })
                  }
                >
                  Fechar
                </Button>
              </Row>
            </div>
          }
        />
      );
    }
  };

  _fetchAnomalies = () => {
    const anomalies = {};
    const PromiseStack = [];
    const { company, shift } = this.props.user;

    const productRef = db
      .collection("companies")
      .doc(company)
      .collection("products");
    const indicatorRef = db
      .collection("companies")
      .doc(company)
      .collection("indicators");
    const shiftRef = db
      .collection("companies")
      .doc(company)
      .collection("shifts");
    const placeRef = db
      .collection("companies")
      .doc(company)
      .collection("places");
    const lineRef = db.collection("companies").doc(company).collection("lines");
    const tableRef = db
      .collection("companies")
      .doc(company)
      .collection("tables");
    const userRef = db.collection("users");

    this.setState({ fetching: true });

    let anomalyQuery = db
      .collection("companies")
      .doc(company)
      .collection("results")
      .orderBy("registeredAt", "desc");

    if (!!shift) {
      anomalyQuery.where("shift", "==", shift);
    }

    anomalyQuery.onSnapshot((anomalySnapshot) => {
      if (!anomalySnapshot.empty) {
        anomalySnapshot.forEach((anomaly) => {
          const {
            product,
            registered,
            registeredAt,
            goal,
            indicator,
            shift,
            place,
            line,
            table,
            user,
          } = anomaly.data();

          if (registered > goal) {
            anomalies[anomaly.id] = {
              ...anomaly.data(),
              id: anomaly.id,
              registeredAt: registeredAt,
            };

            if (anomaly.data().justifiedBy) {
              PromiseStack.push(
                userRef
                  .doc(anomaly.data().justifiedBy)
                  .get()
                  .then(
                    (snap) =>
                      (anomalies[anomaly.id].justifiedBy = snap.data().name)
                  )
                  .catch((e) => console.log(e))
              );
            }

            PromiseStack.push(
              productRef
                .doc(product)
                .get()
                .then(
                  (snap) => (anomalies[anomaly.id].product = snap.data().name)
                )
                .catch((e) => console.log(e)),

              indicatorRef
                .doc(indicator)
                .get()
                .then(
                  (snap) => (anomalies[anomaly.id].indicator = snap.data().name)
                )
                .catch((e) => console.log(e)),

              shiftRef
                .doc(shift.value || shift)
                .get()
                .then(
                  (snap) => (anomalies[anomaly.id].shift = snap.data().name)
                )
                .catch((e) => console.log(e)),

              placeRef
                .doc(place)
                .get()
                .then(
                  (snap) => (anomalies[anomaly.id].place = snap.data().name)
                )
                .catch((e) => console.log(e)),

              lineRef
                .doc(line)
                .get()
                .then((snap) => (anomalies[anomaly.id].line = snap.data().name))
                .catch((e) => console.log(e)),

              tableRef
                .doc(table)
                .get()
                .then(
                  (snap) => (anomalies[anomaly.id].table = snap.data().name)
                )
                .catch((e) => console.log(e)),

              userRef
                .doc(user)
                .get()
                .then((snap) => (anomalies[anomaly.id].user = snap.data().name))
                .catch((e) => console.log(e))
            );
          }
        });
        Promise.all(PromiseStack)
          .then(() =>
            this.setState({ fetching: false, anomalies: toArray(anomalies) })
          )
          .catch((e) => console.log(e));
      } else {
        this.setState({ fetching: false });
      }
    });
  };

  _updateAnomaly = (resultID) => (values) => {
    this.setState({ anomalyModal: false, targetAnomaly: null });
    this.waitAlert("Salvando dados", true);

    const { company } = this.props.user;
    const { cause, solution } = values;
    db.collection("companies")
      .doc(company)
      .collection("results")
      .doc(resultID)
      .update({
        cause,
        solution,
        justifiedBy: this.props.user.id,
      })
      .then(() => {
        this.hideAlert();
        this.notify("Justificativa adicionada", "success");
      })
      .catch((e) => {
        this.hideAlert();
        this.notify("Erro ao adicionar justificativa", "error");
      });
  };

  _renderTableButtons = (value) => {
    if (value.cause && value.solution) {
      return (
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id={`edit_${value.id}`}>Ver Justificativa</Tooltip>}
        >
          <a
            className="btn btn-simple btn-default btn-icon"
            onClick={() =>
              this.setState({ targetAnomaly: value, justificationModal: true })
            }
          >
            <FontAwesomeIcon icon={faClipboard} />
          </a>
        </OverlayTrigger>
      );
    } else {
      return (
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip id={`edit_${value.id}`}>Justificar Anomalia</Tooltip>
          }
        >
          <a
            className="btn btn-simple btn-default btn-icon"
            onClick={() =>
              this.setState({ targetAnomaly: value, anomalyModal: true })
            }
          >
            <FontAwesomeIcon icon={faPencilAlt} />
          </a>
        </OverlayTrigger>
      );
    }
  };

  // solvingShift = () => {
  //   db.collection("companies")
  //     .doc("XhOEDdqINBcrvG9GErhf")
  //     .collection("results")
  //     .doc("0NnRmrEz0jo1vx37V7Hc")
  //     .update({ shift: { label: "Turno 1", value: "8CiGNdCTOMfwFBX27ZR7" } });
  // };

  //Notifications
  notify = (message, level) => {
    this.state._notificationSystem.addNotification({
      title: null,
      message: <b>{message}</b>,
      level,
      position: "tr",
      autoDismiss: 4,
    });
  };

  //SweetAlerts
  hideAlert = () => this.setState({ alert: null });

  waitAlert = (title, showSpinner) => {
    this.setState({
      alert: (
        <SweetAlert
          style={{ display: "block" }}
          title={title}
          onConfirm={() => null}
          showConfirm={false}
        >
          {showSpinner ? <SweetSpinner /> : null}
        </SweetAlert>
      ),
    });
  };
}

const mapStateToProps = (state) => ({ user: state.auth.user });

export default connect(mapStateToProps, null)(Anomalies);



// WEBPACK FOOTER //
// ./src/views/Anomalies/Anomalies.jsx